import usegetdata from '../../Hooks/useGetData';
import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import { UpdateProductdata } from '../../Hooks/useUpdateData';
import usedeletedata from '../../Hooks/useDeleteData';
import {
  Add_New_Dates_For_Payment_Commission,
  Delete_Selected_Schedual_Date,
  Get_All_Schedual_Dates_Type,
  Get_Error,
  Get_Selected_Schedual_Date,
  Update_Selected_Schedual_Date_Type,
} from '../Types';

// Add Commission schedual Data
export const Add_Commission_Schedual_Data_Action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/CommissionSchedualDates`, body);

    dispatch({
      type: Add_New_Dates_For_Payment_Commission,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

// Get All Commission schedual Data
export const Get_All_Commission_Schedual_Data_Action = (body) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/CommissionSchedualDates`);

    dispatch({
      type: Get_All_Schedual_Dates_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

// Delete Selected Commission schedual Data
export const Delete_Selected_Commission_Schedual_Data_Action = (id) => async (dispatch) => {
  try {
    const res = await usedeletedata(`/api/v1/CommissionSchedualDates/${id}`);

    dispatch({
      type: Delete_Selected_Schedual_Date,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

// Get One Selected Schedual Date
export const Get_Selected_Commission_Schedual_Data_Action = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/CommissionSchedualDates/${id}`);

    dispatch({
      type: Get_Selected_Schedual_Date,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

// Update One Selected Schedual Date
export const Update_Selected_Commission_Schedual_Data_Action = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/CommissionSchedualDates/${id}`, body);

    dispatch({
      type: Update_Selected_Schedual_Date_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};
